// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605111100/js/" + chunkId + "." + {"44":"b74b1af7","225":"f4bf7fe9","481":"243db712","486":"10e24a13","770":"234dfb3b"}[chunkId] + ".0.38528596548271543.chunk.js";
};